<template>
    <div class="mc-report-view__table">
      <div class="row">
        <!-- Search -->
        <div class="col-md-12">
          <div class="mc-table-view">
            <div
              id="tickets-table_filter"
              class="dataTables_filter text-md-end float-end"
            >
              <label
                class="d-inline-flex align-items-center mc-table-view__search"
              >
                <i class="mc-fa fas fa-search"></i>
                <b-form-input
                  v-model="filter"
                  type="search"
                  :placeholder="$t('global.search') + '...'"
                  class="ms-2"
                ></b-form-input>
              </label>
            </div>
          </div>
        </div>
        <!-- End search -->
      </div>

      <div class="table-responsive my-3 border border-1" >
        <b-table
          class="datatables"
          :items="tableData"
          :fields="fields"
          responsive="md"
          show-empty
          :empty-text="$t('global.emptyTable')"
          :per-page="perPage"
          :current-page="currentPage"
          :filter="filter"
          :filter-included-fields="filterOn"
          @filtered="onFiltered"
          @row-clicked="onRowClicked"
        >
        </b-table>
      </div>
      <div class="row mt-3">
        <div class="col-sm-12 col-md-6">
          <div id="tickets-table_length" class="dataTables_length">
            <label class="d-inline-flex align-items-center">
              Tampilkan
              <b-form-select
                class="form-select form-select-sm"
                v-model="perPage"
                size="sm"
                :options="pageOptions"
              ></b-form-select>
              entri.
            </label>
          </div>
        </div>
        <div class="col-sm-12 col-md-6">
          <div class="dataTables_paginate paging_simple_numbers float-end">
            <ul class="pagination pagination-rounded mb-0">
              <!-- pagination -->
              <b-pagination
                v-model="currentPage"
                :total-rows="rows"
                :per-page="perPage"
              ></b-pagination>
            </ul>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import { todoComputed, todoMethods } from "@/state/helpers";
export default {
  name: "WorkingHoursTable",
  data() {
    return {
      tableData: [],
      totalRows: 1,
      todoTotalRows: 1,
      currentPage: 1,
      todocurrentPage: 1,
      perPage: 10,
      todoperPage: 10,
      pageOptions: [10, 25, 50, 100],
      todoOptions: [10, 50, 100, 150, 200],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      fields: [
        {
          key: "date_start",
          label: "Tanggal Awal",
          sortable: true,
        },
		{
          key: "date_end",
          label: "Tanggal Akhir",
          sortable: true,
        },
        {
          key: "driver_first",
          label: "Pengemudi Utama",
          sortable: true,
        },
        {
          key: "driver_second",
          label: "Pengemudi Cadangan",
          sortable: true,
        },
		{
          key: "license_plate",
          label: "Plat Nomor",
          sortable: true,
        },
		{
          key: "fleet_type",
          label: "Jenis Kendaraan",
          sortable: true,
        },
        {
          key: "location_start",
          label: "Lokasi Mulai",
          sortable: true,
          thClass: "mc-table--250"
        },
		{
          key: "location_end",
          label: "Lokasi Berhenti",
          sortable: true,
          thClass: "mc-table--250"
        },
        {
          key: "work_hour",
          label: "Jam Kerja",
          sortable: true,
        }
      ],
    };
  },
  computed: {
    ...todoComputed,
    /**
     * Total no. of records
     */
    rows() {
      return this.tableData.length;
    },

    /**
     * Todo list of records
     */
    todoList() {
      return this.todos.length;
    },
  },
  mounted() {
    this.fetchTodos();
    // Set the initial number of items
    this.totalRows = this.tableData.length;

    this.todoTotalRows = this.todos.length;
  },
  methods: {
    ...todoMethods,
    /**
     * Search the table data with search input
     */

    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
  },
};
</script>